import src from "IMAGE";
export default { src, width: 352, height: 220, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAGklEQVR42sXKIQEAAAACIJL/JzvBaKABGe6hTJUA8earZiQAAAAASUVORK5CYII="};
